import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59589844435025:1';
  };
  return <section className="w-full py-12 md:py-16 bg-gradient-to-br from-emerald-700 via-emerald-600 to-emerald-700" data-id="element-109">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-112">
            Empezá hoy a transformar tu consultorio
          </h2>
          <p className="text-emerald-100 text-base md:text-lg mb-8 max-w-2xl mx-auto" data-id="element-113">
            Acceso inmediato a todo el sistema + bonos exclusivos por solo
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-114">
            <span className="text-emerald-200 text-xl md:text-2xl line-through" data-id="element-115">
              $59.990
            </span>
            <span className="text-white text-5xl md:text-6xl font-bold" data-id="element-116">
              $19.990
            </span>
          </div>

          <button onClick={handlePurchase} className="bg-white hover:bg-emerald-50 text-emerald-700 font-bold text-lg md:text-xl py-5 px-10 rounded-2xl shadow-2xl hover:shadow-emerald-900/30 transition-all duration-300 inline-flex items-center gap-3 mb-4" data-id="element-117">
            <Lock className="w-5 h-5 md:w-6 md:h-6" data-id="element-118" />
            COMPRAR EL MEGAPACK AHORA
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-119" />
          </button>

          <div className="text-emerald-100 text-xs md:text-sm flex items-center justify-center gap-2" data-id="element-120">
            <Lock className="w-3.5 h-3.5" data-id="element-121" />
            Compra 100% segura · Acceso inmediato
          </div>
        </motion.div>
      </div>
    </section>;
}